import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import React, { Component } from 'react';
import { connect } from "react-redux";
import {setShowModsModal} from 'actions/index.js';
import EffectMods from 'components/effects/EffectMods.js';
import '../../Modals.scss';

/**
 * Modal responsible for sequence-wide changes like
 * double setting the track length
 */
class ModsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.onClickDone = this.onClickDone.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
    }

    onClickDone() {
        this.props.setShowModsModal(false);
    }

    onClickCancel() {
        this.props.setShowModsModal(false);
    }

    render() {
        return (
            <Modal dialogClassName="preset-modal" show={this.props.show} onHide={this.onClickCancel}>
              <Modal.Header closeButton>
                <Modal.Title>Track Mods</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <EffectMods parameters={this.props.parameters}/>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={this.onClickDone}>
                  Done
                </Button>
                <Button variant="primary" onClick={this.onClickCancel}>
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
        );
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setShowModsModal: (show) => dispatch(setShowModsModal(show)),
    }
};

const mapStateToProps = state => {
    return {
        show: state.sequencer.showModsModal
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModsModal);
